// extracted by mini-css-extract-plugin
export default {"text":"SccopeSelectionByLop_text__xyNmH"};